import { useState, useEffect, useCallback } from 'react';

/**
 * Hook per il rilevamento GPS continuo
 * Ritorna { position, error, loading, refresh }
 */
export default function useGps(options = {}) {
  const { enableHighAccuracy = true, watchMode = false } = options;
  const [position, setPosition] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const getPosition = useCallback(() => {
    if (!navigator.geolocation) {
      setError('Geolocalizzazione non supportata');
      setLoading(false);
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracy: pos.coords.accuracy
        });
        setError(null);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
      { enableHighAccuracy, timeout: 15000, maximumAge: 60000 }
    );
  }, [enableHighAccuracy]);

  useEffect(() => {
    getPosition();

    if (watchMode && navigator.geolocation) {
      const watchId = navigator.geolocation.watchPosition(
        (pos) => {
          setPosition({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            accuracy: pos.coords.accuracy
          });
          setError(null);
        },
        (err) => setError(err.message),
        { enableHighAccuracy, timeout: 15000, maximumAge: 30000 }
      );
      return () => navigator.geolocation.clearWatch(watchId);
    }
  }, [getPosition, watchMode, enableHighAccuracy]);

  return { position, error, loading, refresh: getPosition };
}
